export default "__VITE_ASSET__9Z9Y4yM8__"